module.exports = __webpack_public_path__ + "static/media/29FUNOV10.54a1c6d1.jpg";